export function hideCtaBanner() {
  window.addEventListener("scroll", function () {
    var scrollPosition = window.scrollY;
    var header = document.querySelector("header");

    if (scrollPosition > 100) {
      // Change the value to the scroll position where you want to add the class
      header.classList.add("header-translate");
    } else {
      header.classList.remove("header-translate");
    }
  });
}
